// Single switch for feed motion: body.reduce-motion is set when the viewer
// asked for it in settings OR the OS prefers reduced motion. custom.css keys
// every "stop animating" rule on that class (no @media duplication).
export const REDUCE_MOTION_CLASS = 'reduce-motion';
export const REDUCE_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function shouldReduceMotion(user, matchMedia) {
    if (user?.settings?.reduceMotion) {
        return true;
    }
    if (typeof matchMedia !== 'function') {
        return false;
    }
    try {
        return !!matchMedia(REDUCE_MOTION_QUERY)?.matches;
    } catch (err) {
        return false;
    }
}

export function applyReduceMotion(user, { matchMedia, toggleBodyClasses } = {}) {
    const reduce = shouldReduceMotion(user, matchMedia);
    if (typeof toggleBodyClasses === 'function') {
        toggleBodyClasses(REDUCE_MOTION_CLASS, reduce);
    }
    return reduce;
}
